import React, { Component } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import TextareaAutosize from 'react-autosize-textarea';

import ReactRRuleGenerator, { translations } from '../lib';
import './index.css';

class App extends Component {
  state = {
    rrule: 'FREQ=DAILY;INTERVAL=1',
    isCopied: false,
    language: 'en',
  };

  getTranslation = () => (this.state.language === 'de') ? translations.german : undefined;

  handleChangeLanguage = (event) => {
    event.persist();
    const newLanguage = event.target.value;
    this.setState({ language: newLanguage });
  };

  handleChange = (newRRule) => {
    this.setState({ rrule: newRRule.toString().replace('RRULE:', ''), isCopied: false });
  };

  handleCopy = () => {
    this.setState({ isCopied: true });
  };

  render() {
    const { rrule, isCopied } = this.state;

    return (
      <div>
       <div className="app-header">
          <h1>DealerApps RRule Generator</h1>
        </div>

        <div className="app-desc">
          Recurrence rules generator
        </div>

        <div className="app container">
          <h5><strong>{'Create a new Rule'}</strong></h5>

          <ReactRRuleGenerator
            onChange={this.handleChange}
            value={this.state.rrule}
            config={{
              hideStart: true,
            }}
            translations={this.getTranslation()}
          />
        </div>

        <hr className="mt-5 mb-5" />

        <div className="container">
          <h5><strong>Use this RRule</strong></h5>

          <div className="px-3 pt-3 border rounded">
            <div className="form-group row d-flex align-items-sm-center">

              <div className="col-sm-2 text-sm-right">
                <span className="col-form-label">
                  <strong>
                    RRule
                  </strong>
                </span>
              </div>

              <div className="col-sm-8">
                <TextareaAutosize
                  className={`form-control rrule ${isCopied ? 'rrule-copied' : 'rrule-not-copied'}`}
                  value={rrule}
                  readOnly
                />
              </div>

              <div className="col-sm-2">
                <CopyToClipboard
                  text={rrule}
                  onCopy={this.handleCopy}
                >
                  <button
                    aria-label="Copy generated RRule"
                    className={`btn ${isCopied ? 'btn-secondary' : 'btn-primary'} float-right`}
                  >
                    {isCopied ? 'Copied' : 'Copy'}
                  </button>
                </CopyToClipboard>
              </div>

            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/demo/App.js